import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import api from "../api";

const LABEL = { golf_dinner: "Golf & Dinner", golf_only: "Golf Only", dinner_only: "Dinner Only" };
const BADGE_COLOR = { golf_dinner: "#166534", golf_only: "#1d4ed8", dinner_only: "#7e22ce" };

// A dedicated, organiser-only view of who's voted — separate from the
// public /vote page, which recognises whoever's Player Portal token happens
// to be in the browser and shows THEIR personal voting card first. That's
// right for a player signing in on their own phone, but wrong for an
// organiser who just wants a clean, predictable summary regardless of
// who's logged into what on this machine.
export default function VoteResults() {
  const [event, setEvent] = useState(null);
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/attendance/results").then(res => {
      setEvent(res.data.event);
      setPlayers(res.data.players || []);
    }).catch(() => setError("Failed to load vote results")).finally(() => setLoading(false));
  }, []);

  const counts = { golf_dinner: 0, golf_only: 0, dinner_only: 0, buggy: 0, none: 0 };
  players.forEach(p => {
    if (p.attendance && counts[p.attendance] !== undefined) counts[p.attendance]++;
    else counts.none++;
    if (p.buggy) counts.buggy++;
  });

  const responded = players.filter(p => p.attendance).sort((a, b) => a.name.localeCompare(b.name));
  const noResponse = players.filter(p => !p.attendance).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Layout>
      <div className="flex flex-col h-full">
        <div className="bg-white border-b border-gray-300 px-4 py-3">
          <span className="font-semibold text-sm">Vote Results</span>
          {event && <span className="ml-3 text-xs text-gray-500">{event.name} · {new Date(event.date).toLocaleDateString('en-GB')} · {event.venue}</span>}
        </div>
        {loading && <div className="p-4 text-gray-500 text-sm">Loading...</div>}
        {error && <div className="p-4 text-red-600 text-sm">{error}</div>}
        {!loading && !error && !event && <div className="p-4 text-gray-500 text-sm">No active event.</div>}
        {!loading && !error && event && (
          <div className="flex-1 overflow-auto p-4">
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="text-white text-xs font-bold px-3 py-1.5 rounded-full" style={{ background: BADGE_COLOR.golf_dinner }}>Golf &amp; Dinner: {counts.golf_dinner}</span>
              <span className="text-white text-xs font-bold px-3 py-1.5 rounded-full" style={{ background: BADGE_COLOR.golf_only }}>Golf Only: {counts.golf_only}</span>
              <span className="text-white text-xs font-bold px-3 py-1.5 rounded-full" style={{ background: BADGE_COLOR.dinner_only }}>Dinner Only: {counts.dinner_only}</span>
              <span className="bg-orange-600 text-white text-xs font-bold px-3 py-1.5 rounded-full">🚗 Buggy: {counts.buggy}</span>
              <span className="bg-gray-500 text-white text-xs font-bold px-3 py-1.5 rounded-full">No response: {counts.none}</span>
            </div>

            <div className="bg-white border border-gray-300 rounded-lg overflow-hidden mb-6">
              <div className="bg-green-800 text-white text-xs font-bold px-4 py-2">RESPONDED ({responded.length})</div>
              <table className="w-full text-sm">
                <tbody>
                  {responded.map(p => (
                    <tr key={p.id} className="border-b border-gray-100 last:border-0">
                      <td className="px-4 py-2 font-medium">{p.name}</td>
                      <td className="px-4 py-2 text-right">
                        <span className="text-white text-xs font-bold px-2.5 py-1 rounded-full" style={{ background: BADGE_COLOR[p.attendance] }}>{LABEL[p.attendance]}</span>
                        {p.buggy && <span className="ml-2 text-xs">🚗 Buggy</span>}
                      </td>
                    </tr>
                  ))}
                  {responded.length === 0 && <tr><td className="px-4 py-3 text-gray-400 text-sm">No one has responded yet.</td></tr>}
                </tbody>
              </table>
            </div>

            <div className="bg-white border border-gray-300 rounded-lg overflow-hidden">
              <div className="bg-gray-600 text-white text-xs font-bold px-4 py-2">NO RESPONSE ({noResponse.length})</div>
              <table className="w-full text-sm">
                <tbody>
                  {noResponse.map(p => (
                    <tr key={p.id} className="border-b border-gray-100 last:border-0">
                      <td className="px-4 py-2 text-gray-500">{p.name}</td>
                    </tr>
                  ))}
                  {noResponse.length === 0 && <tr><td className="px-4 py-3 text-gray-400 text-sm">Everyone has responded.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
